import $ from 'jquery';
import { component as defineComponent } from 'flightjs';

var ENTER_KEY = 13;

export default defineComponent(function () {
    var $form, $urlInput, $reasoningInput, $submit, counter, $urlValidationMessage, $urlFieldGroup;

    this.attributes({
        websitesSelector: '.js-websites',
        formSelector: '.js-website-form',
        submitSelector: '.js-submit',
        removeWebsiteSelector: '.js-website-attachment-remove',
    });

    function standardiseHttp(url) {
        if (!/^(http|https):\/\//.test(url)) {
            return 'http://' + url;
        }
        return url;
    }

    this.websites = function () {
        return this.select('websitesSelector');
    };

    this.updateValidation = function () {
        if (!$urlInput.val() && $reasoningInput.val()) {
            $urlValidationMessage.text(
                $('[data-empty-url-message]').attr('data-empty-url-message')
            );
            $urlFieldGroup.attr('data-field-error', 'data-field-error');
        } else {
            $urlFieldGroup.removeAttr('data-field-error');
        }

        $submit.prop('disabled', !$urlInput.val());
    };

    this.resetForm = function () {
        $urlInput.val('').focus();
        $reasoningInput.val('');
        this.updateValidation();
    };

    this.removeWebsite = function (ev, data) {
        ev.preventDefault();

        var index = $(data.el).data('index');
        var $website = this.$node.find('.js-website-attachment-' + index);

        $website.remove();

        this.trigger('websiteInpsirationRemoved');
        this.trigger('formChanged');
    };

    this.injectDataToHtml = function (html) {
        return html
            .replace(/__name__/g, counter)
            .replace(/__url__/g, this.escapeHtml(standardiseHttp($urlInput.val())))
            .replace(/__reasoning__/g, this.escapeHtml($reasoningInput.val()));
    };

    this.addWebsite = function () {
        if (!$urlInput.val()) {
            return;
        }

        var prototype = this.injectDataToHtml($form.data('prototype'));
        var $website = $(prototype);
        this.websites().append($website);
        this.resetForm();

        this.trigger('websiteInpsirationAdded');
        this.trigger('formChanged');
        counter++;
    };

    this.bindEnterToAddWebsite = function (ev) {
        if (ev.keyCode === ENTER_KEY) {
            ev.preventDefault();
            this.addWebsite();
        }
    };

    this.escapeHtml = function (unsafe) {
        return unsafe
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    this.after('initialize', function () {
        $form = this.select('formSelector');
        $urlInput = $form.find('.js-url-input');
        $reasoningInput = $form.find('.js-reasoning-input');
        $submit = this.select('submitSelector');
        $urlValidationMessage = $form.find('#briefform_websites___name___url_validation');
        $urlFieldGroup = $urlValidationMessage.closest('[data-field]');
        counter = this.websites().children().length;

        this.on($urlInput, 'change keyup', this.updateValidation);
        this.on($reasoningInput, 'change keyup', this.updateValidation);
        this.on($urlInput, 'keydown', this.bindEnterToAddWebsite);
        this.on('click', {
            submitSelector: this.addWebsite,
            removeWebsiteSelector: this.removeWebsite,
        });
    });
});



// WEBPACK FOOTER //
// ./src/web/js/app/modules/website-inspiration.js